import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IndicationScheduleOutputDTO } from '../contracts/schedule';

@Injectable({
  providedIn: 'root',
})
export class ScheduleServiceV2 {
  private readonly urlV1 = environment.api;
  private readonly urlV2 = `${environment.api_v2}/v2`;
  private readonly http = inject(HttpClient);

  findAllByIndicationId(indicationId: number): Observable<IndicationScheduleOutputDTO[]> {
    return this.http.get<IndicationScheduleOutputDTO[]>(`${this.urlV1}/schedule/${indicationId}`);
  }
}
